import { useRef } from "react";
import { ReactNode, useState } from "react";

import clsx from "clsx";
import { useOnClickOutside } from "usehooks-ts";

export default function Tooltip({
  children,
  text,
  above = false,
  right = false,
}: {
  children: ReactNode;
  text: string | ReactNode;
  above: boolean;
  right: boolean;
}): ReactNode {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setOpen(false);
  });

  return (
    <button
      ref={ref}
      className="relative"
      onClick={() => setOpen(!open)}
      onKeyUp={(e) => {
        if (e.code === "Escape") {
          setOpen(false);
        }
      }}
    >
      {children}
      <div
        role="tooltip"
        className={clsx(
          open ? "block" : "hidden",
          "absolute z-40 rounded",
          "border-2 border-white bg-theme-primary p-2 text-white",
          "min-h-[80px] min-w-[280px]",
          above ? "bottom-7" : "top-7",
          right ? "-left-8" : "-left-60",
        )}
      >
        {text}
      </div>

      <svg
        viewBox="0 0 80 80"
        className={clsx(
          open ? "block" : "hidden",
          "absolute left-1 z-40 h-4 w-3",
          above ? "-top-3 rotate-180" : "top-4",
        )}
      >
        <polygon
          points="40,10 80,80 0,80"
          className="left- fill-theme-primary stroke-theme-primary"
        />
      </svg>
    </button>
  );
}
